<template>
    <v-container class="integration-view" fluid>
        <v-row dense>

            <!-- edit integration form -->
            <v-col>

                <v-alert
                    border="top"
                    color="green lighten-2"
                    dark
                    dismissible
                    close-text="Close"
                    v-model="successAlert.active"
                >
                  {{ successAlert.message }}
                </v-alert>

                <v-alert
                    border="top"
                    color="red lighten-2"
                    dark
                    dismissible
                    close-text="Close"
                    v-model="errorAlert.active"
                >
                  {{ errorAlert.message }}
                </v-alert>

                <v-card
                    color="light"
                    padding
                    elevation="6">
                    <v-card-title class="headline" v-if="integration">
                        {{ integration.label  }}
                        <v-spacer></v-spacer>
                        <v-switch v-model="isActivate" color="primary" :disabled="true"></v-switch><span class="subtitle-2">Activate</span>
                    </v-card-title>

                    <v-row>
                        <v-col md="8">
                            <div class="pl-4 mb-5">
                                <v-btn
                                    @click="showGetRecordModal = true"
                                    x-small
                                    :disabled="!integration || isDeleted">
                                    <span>
                                        Get Record
                                    </span>
                                </v-btn>

                                <v-btn
                                    class="mx-1"
                                    @click="showSyncBackModal = true"
                                    x-small
                                    :disabled="!integration || isDeleted">
                                    <span>
                                        Sync Back
                                    </span>
                                </v-btn>

                                <v-btn class="mx-1" v-if="id > 0" :href="`/logs?filter=${id}`" x-small>
                                    <span>
                                        View Logs
                                    </span>
                                </v-btn>

                                <v-btn class="mx-1" v-if="id > 0" :href="`/live-rates/logs?filter=${id}`" x-small>
                                    <span>
                                        View Live Rate Logs
                                    </span>
                                </v-btn>

                                <v-btn class="mx-1" v-if="id > 0" :href="`/webhooks?filter=${id}`" x-small>
                                    <span>
                                        View Webhooks
                                    </span>
                                </v-btn>

                                <v-btn class="mx-1" v-if="hasOauth" @click="onOauth2" x-small>
                                    <span>
                                        authenticate
                                    </span>
                                </v-btn>
                            </div>
                        </v-col>
                        <v-col md="4">
                            <IntegrationsLastSync v-if="integration" class="pr-4" :last_syncs="integration.last_syncs" />
                        </v-col>
                    </v-row>

                    <get-record-modal
                        :integration="id"
                        v-if="showGetRecordModal"
                        :targetFields="getTargetFields"
                        @getRecordModalClose="showGetRecordModal = false">
                    </get-record-modal>

                    <sync-back-modal
                        :integration="id"
                        :limited="!isAdmin"
                        v-if="showSyncBackModal"
                        @syncBackModalClose="showSyncBackModal = false">
                    </sync-back-modal>


                    <!-- ADMIN SIDE  -->
                    <div v-if="isAdmin">
                        <integrations-form
                            v-if="integration"
                            :integration="integration"
                            :integration_id="id"
                            :integration_type_id="integration.integration_type_id"
                            :is_disabled="true"
                            submitText="">
                        </integrations-form>

                        <v-progress-linear
                            v-else
                            indeterminate
                            color="primary"
                            class="mb-5"
                        ></v-progress-linear>

                        <div class="mt-5 p-3" v-if="integration && !isDeleted">
                            <integrations-mapping :is_view="true" :integration="integration"></integrations-mapping>
                        </div>
                    </div>

                    <!-- NON ADMIN -->
                    <div v-else>

                        <v-tabs
                            class="fusedship-tab"
                            background-color="white"
                            v-model="tab"
                            color="dark"
                            show-arrows="mobile"
                        >
                             <v-tab href="#value-lookup" v-if="hasLookup">
                                Value Lookup
                            </v-tab>
                            <v-tab href="#packing-rules">
                                Packing Rules
                            </v-tab>
                            <v-tab href="#live-settings" v-if="hasLiverates">
                                Liverate Settings
                            </v-tab>
                            <v-tabs-items v-model="tab" class="fusedship-tab-items" touchless>
                                <v-tab-item value="packing-rules">
                                    <PackingRules :id="id" class="px-5" />
                                </v-tab-item>
                                <v-tab-item value="live-settings">
                                    <LiverateSettings :id="id" />
                                </v-tab-item>
                                <v-tab-item value="value-lookup">
                                    <IntegrationsValueLookupsForm :id="id" :direction="'to_machship'" />
                                </v-tab-item>
                            </v-tabs-items>
                        </v-tabs>


                    </div>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import IntegrationsForm from './forms/IntegrationsForm.vue'
import IntegrationsMapping from './IntegrationsMapping.vue'
import GetRecordModal from "./modal/GetRecordModal"
import SyncBackModal from "./modal/SyncBackModal"
import IntegrationsLastSync from "./IntegrationsLastSync"
import { CompanyLocation, PackingRules, LiverateSettings } from "./tabs"
import IntegrationsValueLookupsForm from './forms/IntegrationsValueLookupsForm'
import { EventBus } from '@/js/event-bus.js';

import { mapGetters } from 'vuex';

export default {
    components: {
        IntegrationsForm,
        IntegrationsMapping,
        IntegrationsLastSync,
        GetRecordModal,
        SyncBackModal,
        CompanyLocation,
        PackingRules,
        LiverateSettings,
        IntegrationsValueLookupsForm
    },

    data() {
        return {
            id: null,
            integration: null,
            tab: 'tab-machship-keys',
            isActivate: null,
            showGetRecordModal: false,
            showSyncBackModal: false,
            tab: 'carrier-services',
            successAlert: {
                active: false,
                message: ''
            },
            errorAlert: {
                active: false,
                message: ''
            },
            isDeleted: null
        }
    },

    computed: {
        isAdmin() {
            return this.$store?.getters?.isAdmin
        },

        hasLiverates() {
            return this.integration?.live_rate_active
        },

        hasOauth() {
            return this.integration?.has_oauth2;
        },

        getTargetFields() {
            return this.integration.target_fields ?? [];
        },

        ...mapGetters(['isAdmin', 'getActiveIntegrationMeta']),

        hasLookup() {
            return !this.isAdmin &&
                this.getActiveIntegrationMeta &&
                this.getActiveIntegrationMeta.attributes?.other_menu?.includes('value_lookup')
        }
    },

    mounted() {
        this.id = parseInt(this.$route.params.id)

        // Handle flash messages from query parameters
        const query = this.$route.query;

        if (query.flash_success) {
            this.successAlert.message = query.flash_success;
            this.successAlert.active = true;
            // Remove query param from URL without reloading
            this.$router.replace({ query: { ...query, flash_success: undefined } });
        }

        if (query.flash_error) {
            this.errorAlert.message = query.flash_error;
            this.errorAlert.active = true;
            // Remove query param from URL without reloading
            this.$router.replace({ query: { ...query, flash_error: undefined } });
        }

        if (!this.isAdmin) {
            let user = this.$store.getters.getUser

            let index = user.integration_ids.findIndex(id => id === this.id);
            if (index <= -1) {
                this.$router.replace('/integrations')
            }
        }

        this.$http
            .get('/api/integrations/' + this.id)
            .then(({ data }) => {
                this.integration = data.data.attributes
                this.isActivate = this.integration.integration_status == 'active' ? true : false
                this.isDeleted = this.integration.deleted_at ? true : false
            })
            .catch(err => {
                EventBus.$emit('show-error', err);
            })
    },

    methods: {
        onOauth2() {
            window.location.href = '/oauth2/' + this.id + '/init?referrer=' + window.location.href;
        }
    }
}
</script>